// extracted by mini-css-extract-plugin
export default {"dialog--footer":"Mt3H-s5lJcrrflB+e4C27vLsyeF6uJ1Iwz8KIQAo90o=","dialog--footer__padding-off":"OrlysWh3Z8oFEJ+MmzbhOoGo1hoeiD0tK9h8LpAHTMc="};